import { ApiConfig, HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { ReportPrintQuery, ReportPrintQueryParameters, ReportPrintResult } from '../queries/report-print.query-base';

export interface PurchasesByPeriodPrintingResult extends ReportPrintResult { }

export interface PurchasesByPeriodPrintingParameters extends ReportPrintQueryParameters { }

export class PurchasesByPeriodPrintingQuery extends ReportPrintQuery<PurchasesByPeriodPrintingResult> {
    public constructor(parameters: PurchasesByPeriodPrintingParameters) {
        super(parameters);
    }
}

export class PurchasesByPeriodPrintingQueryHandlerBase implements QueryHandler<PurchasesByPeriodPrintingQuery, PurchasesByPeriodPrintingResult> {
    private static Url = TaggedUrl.join('purchaseByPeriod/printing', [Tags.Api]);

    public constructor(private readonly http: HttpService) {  }

    public async handleAsync({ parameters }: PurchasesByPeriodPrintingQuery): Promise<PurchasesByPeriodPrintingResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            ecoMode: parameters.ecoMode,
            landscape: parameters.landscape,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns,
                summary: parameters.summary,
                report: 'ZakupyWOkresie'
            }
        };

        const { data } = await this.http.post<{ url: string; }>(PurchasesByPeriodPrintingQueryHandlerBase.Url, requestData, {timeout: 3 * MS_PER_MINUTE });
        return {
            url: `${ApiConfig.baseUrl}${data.url}`
        };
    }
}
